import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const CreditCard = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M14.6667 6.66667H1.33333M7.33333 9.33333H3.99999M1.33333 5.46667V10.5333C1.33333 11.2801 1.33333 11.6535 1.47865 11.9387C1.60648 12.1895 1.81045 12.3935 2.06134 12.5213C2.34655 12.6667 2.71992 12.6667 3.46666 12.6667H12.5333C13.2801 12.6667 13.6535 12.6667 13.9387 12.5213C14.1895 12.3935 14.3935 12.1895 14.5213 11.9387C14.6667 11.6535 14.6667 11.2801 14.6667 10.5333V5.46667C14.6667 4.71993 14.6667 4.34656 14.5213 4.06135C14.3935 3.81047 14.1895 3.60649 13.9387 3.47866C13.6535 3.33333 13.2801 3.33333 12.5333 3.33333H3.46666C2.71993 3.33333 2.34655 3.33333 2.06134 3.47866C1.81046 3.60649 1.60648 3.81046 1.47865 4.06135C1.33333 4.34656 1.33333 4.71993 1.33333 5.46667Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(CreditCard);
